export default __webpack_public_path__ + "static/media/15.f7e0d9fe.svg";